import { useFormContext, useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { useErrorContext } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContext';
import { WebEDIError } from 'services/webediErrors/types';
import { useDateConfigurations } from 'components/DataTable/cells/WebEDI/cellHelpers';
import { DisplayModes } from 'components/DataTable/Types';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { SchemableFormInput } from 'components/Form/SchemableFormInput/SchemableFormInput';
import { useFieldState } from 'components/SchemableForm/hooks/useFieldState';
import { Translate } from 'components/Translate/Translate';

type DateFieldProps = {
  field: ui.DateField | ui.DateTimeField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};
export const DateField = ({ field, fieldId, isReadOnly, mode, variant }: DateFieldProps) => {
  const value = useWatch({ name: fieldId });
  const { register } = useFormContext();
  const { service } = useErrorContext<WebEDIError>();
  const error = service.useErrorById(fieldId);
  const numberOfErrors = service.useNumberOfActiveErrors();
  const setCurrentError = service.setCurrentError;
  const fieldState = useFieldState(fieldId, error);
  const { formattedValue } = useDateConfigurations({
    value,
    mode,
  });

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={formattedValue}
        label={field.label}
        totalNumberOfErrors={numberOfErrors}
        error={error}
        fieldId={fieldId}
        onShowFieldErrorModal={() => error && setCurrentError(error)}
        description={field.description}
      />
    );
  }
  return (
    <SchemableFormInput
      type={field.type === ui.FieldTypes.date ? 'date' : 'datetime-local'}
      label={field.label}
      description={field.description ? <Translate i18nKey={field.description} /> : undefined}
      error={error}
      totalNumberOfErrors={numberOfErrors}
      {...register(fieldId)}
      value={formattedValue}
      onShowFieldErrorModal={() => error && setCurrentError(error)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      variant={variant}
      valueDescription={field.value_description}
      fieldState={fieldState}
    />
  );
};
